module.exports = __webpack_public_path__ + "static/ce-mark-704d9d312b0e86294ade6145c5f249df.png";